import { toRefs as r, openBlock as o, createBlock as s, withCtx as a, renderSlot as n } from "vue";
import p from "./design-system.es94.js";
import { createListProvider as l } from "./design-system.es34.js";
const d = /* @__PURE__ */ Object.assign({
  name: "DsList"
}, {
  __name: "List",
  props: {
    /**
     * Defines the border style of the list items in this list.
     */
    border: {
      type: [String, Boolean],
      default: !1
    }
  },
  setup(t) {
    return l(r(t)), (e, i) => (o(), s(p, null, {
      default: a(() => [
        n(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
export {
  d as default
};
//# sourceMappingURL=design-system.es33.js.map
